(function () {
    'use strict';

    angular
        .module('app')
        .factory('UserService', UserService);

    UserService.$inject = ['$http', '$q', '$localStorage', 'WebAPIUrl', 'SharedData', 'WebApiService'];

    function UserService($http, $q, $localStorage, WebAPIUrl, SharedData, WebApiService) {

        var service = {
            registerUser: registerUser,
            getUsers: getUsers,
            getUser: getUser,
            getUserRole: getUserRole,
            getUsersByBrand: getUsersByBrand,
            getUserBrandAssignment: getUserBrandAssignment,
            getUserBrandAssignmentForEditingUser: getUserBrandAssignmentForEditingUser,
            getWFEventAssignment: getWFEventAssignment,
            getUserFactories: getUserFactories,
            getUserByNameandBrand: getUserByNameandBrand,
            createUser: createUser,
            saveUser: saveUser,
            saveUserProfile: saveUserProfile,
            saveUserTheme: saveUserTheme,
            confirmEmail: confirmEmail,
            logLastUseProject: logLastUseProject,
            getLastViewedProjects: getLastViewedProjects,
            shouldShowStartupHelp: shouldShowStartupHelp,
            setShowStartupHelp: setShowStartupHelp,
            getErrors: getErrors,
            getUserAccessReport: getUserAccessReport,
            getProjectCreateDefaults: getProjectCreateDefaults,
            saveProjectCreateDefaults: saveProjectCreateDefaults,
            getSizeRangePresets: getSizeRangePresets,
            saveSizeRangePresets: saveSizeRangePresets,
            deleteSizeRangePreset: deleteSizeRangePreset
        };


        return service;

        function getUserAccessReport(searchModel) {
            return WebApiService.get("/api/User/UserAccessReport", searchModel);
        }

        function getProjectCreateDefaults(brandId) {
            return WebApiService.get("/api/User/GetProjectCreateDefaults?brandId=" + brandId);
        }

        function saveProjectCreateDefaults(defaults) {
            return WebApiService.postJson("/api/User/SaveProjectCreateDefaults", defaults);
        }

        function getSizeRangePresets() {
            return WebApiService.get("/api/User/SizeRangePresets");
        }

        function saveSizeRangePresets(defaults) {
            return WebApiService.postJson("/api/User/SaveSizeRangePresets", defaults);
        }

        function deleteSizeRangePreset(id) {
            return WebApiService.postJson("/api/User/DeleteSizeRangePreset?id=" + id);
        }

        function registerUser(userData) {
            var deferred = $q.defer();

            $http({
                method: 'POST',
                url: WebAPIUrl + '/api/Account/Register',
                data: userData,
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        }

        function getUsers(brandId, roleId) {

            var deferred = $q.defer();

            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/User/GetUsers?brandId=' + brandId + '&roleId=' + roleId,
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        }

        function getUser(userId) {

            var deferred = $q.defer();

            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/User/GetUser?UserId=' + userId,
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);

            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        }

        function getUserRole(userId) {

            var deferred = $q.defer();

            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/User/GetUserRole?UserId=' + userId,
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        }

        function getUsersByBrand(brandId) {

            var deferred = $q.defer();

            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/User/GetUsersByBrand?BrandId=' + brandId,
                ignoreLoadingBar: true,
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);

            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        }

        function getUserBrandAssignment(userId) {

            var deferred = $q.defer();

            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/User/GetUserBrandAssignment?UserId=' + userId,
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);

            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        }

        function getUserBrandAssignmentForEditingUser(userId, editingUserId) {

            var deferred = $q.defer();

            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/User/GetUserBrandAssignment?UserId=' + userId + '&editingUserId=' + editingUserId,
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);

            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        }

        function getWFEventAssignment(userId) {

            var deferred = $q.defer();

            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/User/GetWFEventAssignment?UserId=' + userId,
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        }

        function getUserFactories(userId) {

            var deferred = $q.defer();

            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/User/GetUserFactories?UserId=' + userId,
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        }

        function getUserByNameandBrand(brandId, userFirstandLastName) {

            var deferred = $q.defer();

            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/User/UserByNameandBrand?brandId=' + brandId + '&userFirstandLastName=' + userFirstandLastName,
                ignoreLoadingBar: true
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);

            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        }

        function createUser(userData) {
            var deferred = $q.defer();
            $http({
                method: 'POST',
                url: WebAPIUrl + "/api/User/CreateUser",
                data: userData,
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        }

        function saveUser(userData) {
            var deferred = $q.defer();
            $http({
                method: 'POST',
                url: WebAPIUrl + "/api/User/UpdateUser",
                headers: { 'Content-Type': 'application/json' },
                data: JSON.stringify(userData),
                ignoreLoadingBar: true
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        }

        function saveUserProfile(userData) {
            var deferred = $q.defer();
            $http({
                method: 'POST',
                url: WebAPIUrl + "/api/User/UpdateUserProfile",
                data: userData,
                ignoreLoadingBar: true
            }).success(function (data, status, headers, cfg) {
                var currentUser = $localStorage.currentUser;

                if (!userData.DefaultSeasonId)
                    userData.DefaultSeasonId = 0;
                if (!userData.DefaultBrandId)
                    userData.DefaultBrandId = 0;
                if (!userData.DefaultDivisionKey)
                    userData.DefaultDivisionKey = "";

                userData.UseDefaultsInQuickSearch = userData.UseDefaultsInQuickSearch === true;

                if (!currentUser) {
                    currentUser = {};
                }

                currentUser.defaultBrandId = userData.DefaultBrandId;
                currentUser.defaultSeasonId = userData.DefaultSeasonId;
                currentUser.defaultDivisionKey = userData.DefaultDivisionKey;
                currentUser.useDefaultsInQuickSearch = userData.UseDefaultsInQuickSearch;

                $localStorage.currentUser = currentUser;

                SharedData.setUserDefaults(userData.DefaultBrandId, userData.DefaultSeasonId, userData.DefaultDivisionKey, userData.UseDefaultsInQuickSearch);
                SharedData.triggerRefresh();

                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        }

        function saveUserTheme(userId, themeID) {
            var deferred = $q.defer();
            $http({
                method: 'POST',
                url: WebAPIUrl + "/api/User/UpdateUserTheme?UserId=" + userId + '&ThemeID=' + themeID,
                ignoreLoadingBar: true
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        }

        function confirmEmail(userData) {
            var deferred = $q.defer();
            $http({
                method: 'POST',
                url: WebAPIUrl + "/api/Account/ConfirmEmail",
                data: userData,
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(status);
            });

            return deferred.promise;
        }

        function logLastUseProject(userData) {
            var deferred = $q.defer();
            $http({
                method: 'POST',
                url: WebAPIUrl + "/api/User/LogLastUseProject",
                data: userData,
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(status);
            });
        }

        function getLastViewedProjects(ignoreLoader) {
            return WebApiService.get("/api/User/GetLastViewedProjects", '', '', ignoreLoader);
        }

        function shouldShowStartupHelp() {
            var deferred = $q.defer();
            $http({
                method: "GET",
                url: WebAPIUrl + "/api/User/ShouldShowStartupHelp"
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });
            return deferred.promise;
        }

        function setShowStartupHelp(show) {
            var deferred = $q.defer();
            $http({
                method: "POST",
                url: WebAPIUrl + "/api/User/SetShowStartupHelp?show=" + show
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });
            return deferred.promise;
        }

        function getErrors(errorSearchModel) {
            return WebApiService.get("/api/User/GetErrors", errorSearchModel, "", false);
        }
    }
})();
